import { ApolloCache, ApolloError, DefaultContext, FetchResult, MutationFunctionOptions } from '@apollo/client'

export type Mutation<TData, TVariables, TContext = DefaultContext, TCache extends ApolloCache<any> = ApolloCache<any>> = (
  options?: MutationFunctionOptions<TData, TVariables, TContext, TCache>,
) => Promise<FetchResult<TData>>

export type MutationResult<TData> = {
  result?: FetchResult<TData>
  apolloError?: ApolloError
  error?: any
}

export default async function syncMutation<TData, TVariables, TContext = DefaultContext, TCache extends ApolloCache<any> = ApolloCache<any>>(
  mutation: Mutation<TData, TVariables, TContext, TCache>,
  options?: MutationFunctionOptions<TData, TVariables, TContext, TCache>,
): Promise<MutationResult<TData>> {
  try {
    const result = await mutation(options)
    const apolloError = result.errors && new ApolloError({ graphQLErrors: result.errors })
    return { result, apolloError: apolloError, error: apolloError }
  } catch (e) {
    let apolloError: ApolloError | undefined = undefined
    if (e instanceof ApolloError) {
      apolloError = e
    }
    return { apolloError, error: e }
  }
}
